import { Component } from 'react'
import { Wrap } from '../ManageLoader/ManageLoaderStyles'
import { Button } from 'components/Button'
import LogRocket from 'logrocket'

// this is kinda obnoxious to work with in dev mode because errors produce that react error overlay thing
//
// depending on context, some workarounds include:
//    a) deal with the pain
//    b) add `iframe { display: none }` to GlobalStyle.ts (dont commit!)
//    c) `yarn build && npx serve -s build -p 3001` (slow)
//
// use (b) during iterative development, then confirm your work against a prod build with (c)

interface ErrorBoundaryProps {
  children: React.ReactNode
}

interface ErrorBoundaryState {
  error: Error | unknown
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
    }
  }

  resetCount = 0

  componentDidCatch = (error, errorInfo) => {
    // the apm agent picks up on the error automagically;
    // we don't need to manually send it.
    console.warn(`Error boundary handled an uncaught error`, {
      error,
      errorInfo,
    })
    try {
      LogRocket.captureException(error, {
        extra: { info: errorInfo, page: 'BrokenBong' },
      })
    } catch (e) {
      console.error(
        'Failed to capture exception for logrocket',
        error,
        errorInfo
      )
    }

    this.setState({ error })
  }

  resetError = () => {
    // since we're just reloading the page here,
    // we don't care about resetting error state
    window.location.reload()
  }

  render() {
    if (this.state.error) {
      return (
        <Wrap
          style={{ flexDirection: 'column', gap: '0.5rem' }}
          id="error-boundary-wrap"
        >
          <h1 style={{ margin: '0 0 1rem 0' }}>Something went wrong</h1>
          <p style={{ margin: 0 }}>We've sent an error report to our team.</p>
          <p style={{ margin: 0 }}>
            Please try again and contact support if the problem persists.
          </p>
          <br />
          <Button color="secondary" onClick={this.resetError}>
            refresh
          </Button>
        </Wrap>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
